/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CorrectionDashboardDetailItemRepositoryResponse } from "../types/CorrectionDashboardDetailItemRepositoryResponse.ts";

export const correctionDashboardDetailItemRepositoryResponseSchema = z.object({
  id: z.optional(
    z
      .number()
      .int()
      .describe("ID do item de detalhe do dashboard de correção."),
  ),
  examName: z
    .string()
    .describe("Nome da prova associada à tarefa de correção.")
    .nullish(),
  startDate: z.optional(
    z
      .string()
      .datetime()
      .describe("Data de início do período de correção da prova."),
  ),
  endDate: z.optional(
    z
      .string()
      .datetime()
      .describe("Data de término do período de correção da prova."),
  ),
  isOnDemand: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a prova pertence a uma disciplina ofertada no formato on demand.",
      ),
  ),
  correctionPendingCount: z.optional(
    z
      .number()
      .int()
      .describe("Quantidade de correções pendentes para a prova no período."),
  ),
}) as unknown as ToZod<CorrectionDashboardDetailItemRepositoryResponse>;
